/*
Copyright (c) 2012, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://yuilibrary.com/license/
*/
exports.jsmin = require('./jsminify').jsminify;
exports.cssmin = require('./cssmin').cssmin;
